import ClientsDashboard from './ClientsDashboard';

export default ClientsDashboard; 